import { useRef, useState } from 'react';

import Tooltip from '@components/ui/Tooltip/next';
import palette from '@utils/theme/palette';
import { useOutsideClick } from '@hooks/hooks';
import { DifferenceIcon, NoItemDiffList } from '@assets/icons';
import CustomIcon from '@components/utils/CustomIcon';
import Typography from '@components/Typography';

import { DiffBox } from '../HeaderStyles';
import { NoItemContainer } from './styled';

const NoItemDifferenceList = () => {
  const [visible, setVisible] = useState(false);

  const ref = useRef(null);

  useOutsideClick(ref, () => {
    setVisible(false);
  });

  const showTooltip = () => {
    setVisible(!visible);
  };

  return (
    <Tooltip
      getPopupContainer={(triggerNode) => triggerNode}
      trigger='hover'
      borderRadius='8px'
      overlayInnerStyle={{
        borderRadius: '8px',
        border: 'none',
        backgroundColor: palette.white,
        width: '300px',
        padding: '8px',
      }}
      placement='bottomRight'
      arrowColor={palette.white}
      open={visible}
      title={
        <NoItemContainer>
          <CustomIcon icon={NoItemDiffList} width={70} height={70} />
          <Typography
            variant='caption2'
            weight='SemiBold'
            color='D400'
            as='div'
            style={{ textAlign: 'center' }}
          >
            Karşılaştırma listenizde otel bulunmamaktadır.
          </Typography>
          <Typography
            variant='caption2'
            weight='Regular'
            color='D100'
            as='div'
            style={{ textAlign: 'center' }}
          >
            Otel karşılaştırması yapabilmek için listenize otel ekleyiniz.
          </Typography>
        </NoItemContainer>
      }
    >
      <DiffBox ref={ref} onClick={showTooltip}>
        <CustomIcon
          icon={DifferenceIcon}
          width={24}
          height={24}
          paletteColor='D400'
        />
      </DiffBox>
    </Tooltip>
  );
};

export default NoItemDifferenceList;
